module.exports = __webpack_public_path__ + "img/12.4cb1621c.png";